<template>
	<template v-if="category">

		<div class="bg-white py-2">
			<div class="container">
				<div class="d-flex align-items-center">

					<h1 class="title-primary m-0">{{category.title}}</h1>

					<div class="ms-auto d-none d-md-block">
						<button type="button" class="btn btn-primary" @click="addShelf">Добавить полку</button>
					</div>

				</div>
			</div>
		</div>

		<div class="container mt-5">

			<div v-if="shelves === null">
				<p>loading ...</p>
			</div>
			<div v-else-if="shelves.length">
				<div v-for="shelf in shelves" :key="shelf.id">

					<div class="shelf">
						<shelf-container
							:shelf="shelf"
							@removed="eventRemoveShelf"
							@updated="eventUpdateShelf"
							@book-added="eventBookAdded"
						>
							<template #content="{method}">

								<header class="shelf__header gap-3">

									<div class="dropdown shelf__menu">
										<button class="btn shelf__btn border-0" type="button" data-bs-toggle="dropdown">
											<span class="shelf__menu-bar"></span>
											<span class="shelf__menu-bar"></span>
											<span class="shelf__menu-bar"></span>
										</button>
										<nav class="dropdown-menu">
											<a class="dropdown-item" href="#" @click.prevent="method.edit">Редактировать полку</a>
											<a class="dropdown-item text-danger" href="#" @click.prevent="method.remove">Удалить полку</a>
										</nav>
									</div>

									<h2 class="shelf__name" style="top: -2px;">
										<router-link class="shelf__name-link" :to="{name: 'shelf-view', params: {idShelf: shelf.id}}">{{shelf.name}}</router-link>
									</h2>

<!--									<div class="d-none d-md-block">-->
<!--										<button type="button" class="btn shelf__btn text-primary border-0" @click="method.addBook">-->
<!--											<svg class="ms-1 me-2" width="24" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">-->
<!--												<g fill="currentColor">-->
<!--													<path d="M32,23.001c0-3.917-2.506-7.24-5.998-8.477V4h-2V1.999h2V0h-23C2.918,0.004,2.294-0.008,1.556,0.354   C0.808,0.686-0.034,1.645,0.001,3c0,0.006,0.001,0.012,0.001,0.018V30c0,2,2,2,2,2h21.081l-0.007-0.004   C28.013,31.955,32,27.946,32,23.001z M2.853,3.981C2.675,3.955,2.418,3.869,2.274,3.743C2.136,3.609,2.017,3.5,2.002,3   c0.033-0.646,0.194-0.686,0.447-0.856c0.13-0.065,0.289-0.107,0.404-0.125C2.97,1.997,3,2.005,3.002,1.999h19V4h-19   C3,4,2.97,4.002,2.853,3.981z M4,30V6h20v8.06C23.671,14.023,23.337,14,22.998,14c-2.142,0-4.106,0.751-5.651,2H6v2h9.516   c-0.413,0.616-0.743,1.289-0.995,2H6v2h8.057c-0.036,0.329-0.059,0.662-0.059,1.001c0,2.829,1.307,5.35,3.348,6.999H4z M23,30   c-3.865-0.008-6.994-3.135-7-6.999c0.006-3.865,3.135-6.995,7-7c3.865,0.006,6.992,3.135,7,7C29.992,26.865,26.865,29.992,23,30z    M22,12H6v2h16V12z"/>-->
<!--													<polygon points="28,22 24.002,22 24.002,18 22,18 22,22 18,22 18,24 22,24 22,28 24.002,28 24.002,24 28,24   "/>-->
<!--												</g>-->
<!--											</svg>-->
<!--											<span class="d-inline-block text-start" style="line-height: 0.9; font-size: 14px; vertical-align: top; font-weight: 400;">-->
<!--												добавить<br>книгу-->
<!--											</span>-->
<!--										</button>-->
<!--									</div>-->

								</header>

								<div class="shelf__body" :class="{
									'py-3': !shelf.books.length
									}">
									<div class="row g-3 g-lg-5">
										<div v-for="book in shelf.books" :key="book.id" class="col-6 col-sm-4 col-lg-3">

											<book-card :book="book" :shelf="{id: shelf.id}"/>

										</div>
										<div class="col-6 col-sm-4 col-lg-3">
											<div class="ratio ratio-1x1">
												<button type="button" class="btn bg-white btn-link" @click="method.addBook" style="line-height: 1;">
													<svg width="52" height="52" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
														<path fill="currentColor" d="M3 4.5C3 3.11929 4.11929 2 5.5 2H17C18.3807 2 19.5 3.11929 19.5 4.5V11.3135C19.0218 11.159 18.5195 11.0585 18 11.0189V4.5C18 3.94772 17.5523 3.5 17 3.5H5.5C4.94772 3.5 4.5 3.94772 4.5 4.5V18H11.0189C11.0585 18.5195 11.159 19.0218 11.3135 19.5H4.5C4.5 20.0523 4.94772 20.5 5.5 20.5H11.7322C12.0194 21.051 12.3832 21.5557 12.8096 22H5.5C4.11929 22 3 20.8807 3 19.5V4.5ZM17.5 12C20.5376 12 23 14.4624 23 17.5C23 20.5376 20.5376 23 17.5 23C14.4624 23 12 20.5376 12 17.5C12 14.4624 14.4624 12 17.5 12ZM18.0011 20.5035L18.0006 18H20.503C20.7792 18 21.003 17.7762 21.003 17.5C21.003 17.2239 20.7792 17 20.503 17H18.0005L18 14.4993C18 14.2231 17.7761 13.9993 17.5 13.9993C17.2239 13.9993 17 14.2231 17 14.4993L17.0005 17H14.4961C14.22 17 13.9961 17.2239 13.9961 17.5C13.9961 17.7762 14.22 18 14.4961 18H17.0006L17.0011 20.5035C17.0011 20.7797 17.225 21.0035 17.5011 21.0035C17.7773 21.0035 18.0011 20.7797 18.0011 20.5035ZM6 6C6 5.44772 6.44772 5 7 5H15C15.5523 5 16 5.44772 16 6V8C16 8.55228 15.5523 9 15 9H7C6.44772 9 6 8.55228 6 8V6ZM7.5 7.5H14.5V6.5H7.5V7.5Z"/>
													</svg>
													<span class="d-block mt-2">Добавить книгу</span>
												</button>
											</div>
										</div>
									</div>

								</div>

							</template>
						</shelf-container>
					</div>

					<hr size="2" class="my-5 bg-white opacity-50">

				</div>
			</div>
			<div v-else class="mt-5">
				<p class="text-muted text-center">Похоже на то, что полки не прибиты</p>
			</div>

		</div>

		<fab-dropdown>
			<a type="button" class="dropdown-item" @click="addShelf">Добавить полку</a>
		</fab-dropdown>

	</template>
</template>
<script>
import CATEGORY from '@/models/category'
import SHELF from '@/models/shelf'

import FabDropdown from '@/components/fab-dropdown'
import BookCard from '@/components/book-card'
import ShelfModal from '@/modals/shelf-instance'
import ShelfContainer from '@/components/shelf-container'

export default {
	data() {
		return {
			category: null,
			shelves: [],
		}
	},
	methods: {
		// load books from server
		loadShelves() {
			this.shelves = null;
			this.userapi.get(`racks?category=${this.category.id}`).then(response => {
				const data = response.data.data;

				this.shelves = Array.isArray(data) ? data.map(
					item => SHELF.formatServerData(item)
				) : [];
			});
		},

		// refresh view
		refresh() {
			this.loadShelves();
		},

		// open shelf instance form modal
		addShelf() {
			this.$vfm.show({component: ShelfModal}, {
				category: this.category,
				onSuccess: (mode, data) => this.shelves.push(SHELF.formatServerData(data))
			});
		},

		// shelf was updated
		eventUpdateShelf(id, mode, data) {
			const dataUpdated = SHELF.formatServerData(data);

			if (mode === 'edit') {
				_.findByID(this.shelves, id, (key, where) => {
					where[key] = dataUpdated;
				});
			} else if (mode === 'add') {
				this.shelves.push(dataUpdated);
			}
		},

		// shelf was removed
		eventRemoveShelf(id) {
			_.findByID(this.shelves, id, (key, where) => where.splice(key, 1));
		},

		// book was added to shelf
		eventBookAdded(id, book) {
			_.findByID(this.shelves, id, (key, where) => where[key].books.push(book));
		}
	},
	beforeRouteEnter(to, from, next) {

		next(vm => {

			vm.category = CATEGORY.find(to.meta.category);

			if (vm.category) {
				vm.refresh();
			} else {
				vm.$router.push({
					name: 'not-found',
					params: { pathMatch: to.path.substring(1).split('/') },
				});
			}

		});

	},
	components: {
		BookCard,
		ShelfContainer,
		FabDropdown
	}
}
</script>